
import { defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { PlayCircleFilled, RightOutlined, DoubleRightOutlined } from '@ant-design/icons-vue'
import jfshool from '@/api/jfschool'
import Card from './card.vue'
import store from '@/store'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
interface pageDataType {
  currentMenuCode: string
  currentCourses: any
  currentGroupName: string
  delicate: any
  recommendCourses: any
  subject: any
  theme: string
  loading: boolean
}
export default defineComponent({
  components: { PlayCircleFilled, RightOutlined, DoubleRightOutlined, Card },
  setup() {
    const route = useRoute()
    const pageData: pageDataType = reactive({
      currentMenuCode: '',
      currentCourses: [] as any,
      currentGroupName: '',
      delicate: [],
      recommendCourses: [],
      subject: [],
      theme: (route.query.theme || '').toString() || 'light',
      loading: false
    })
    function getName(course: any) {
      let name = course.courseName
      if (route.query.softNameAbbr === 'jfzt') {
        // 旗舰
        name = course.chapterName || name
      } else if (route.query.softNameAbbr === 'jfztADV') {
        // 擒龙
        name = course.lessonName || name
      }
      return name
    }
    function getRecommendCourses() {
      pageData.loading = true
      const data: any = {}
      data.data = {}
      data.headers = {
        // 'Content-Type': 'application/json',
        appcode: store.state.pcqueryInfo.appcode
      }
      jfshool.getRecommendCourses(data).then((res: any) => {
        pageData.loading = false
        const { delicate, recommendCourses, subject } = res.data
        pageData.delicate = delicate
        pageData.currentMenuCode = pageData.delicate[0].groupCode
        pageData.currentCourses = pageData.delicate[0].courses
        pageData.currentGroupName = pageData.delicate[0].groupName
        pageData.subject = subject
        pageData.recommendCourses = recommendCourses
      })
    }
    getRecommendCourses()
    function changeCurrentMenu(code: string, idx: number) {
      pageData.currentMenuCode = code
      pageData.currentCourses = pageData.delicate[idx].courses
      pageData.currentGroupName = pageData.delicate[idx].groupName
    }
    function jumpToCourse(p: { courseNo: string; lessonNo?: string }, groupName?: string) {
      if (!route.query.token) {
        gotoClientLogin()
        return
      }
      const obj: any = {
        name: 'coursedetail',
        query: {
          ...route.query,
          courseNo: p.courseNo
        }
      }
      if (groupName !== undefined) {
        obj.params = {
          groupName: groupName
        }
      }
      if (p.lessonNo) {
        obj.query.lessonNo = p.lessonNo
      }
      router.push(obj)
    }
    function jumpToGroup(code: string, name: string) {
      router.push({
        name: 'specialcourse',
        query: {
          ...route.query,
          groupCode: code,
          groupName: name
        }
      })
    }
    function jumpToAllGroup() {
      router.push({
        name: 'selectedtopics',
        query: {
          ...route.query
        }
      })
    }
    function jumpToAllCourse() {
      router.push({
        name: 'allcourse',
        query: {
          ...route.query
        }
      })
    }
    watch(
      () => route.query.theme,
      () => {
        pageData.theme = route.query.theme as string
      }
    )
    return {
      ...toRefs(pageData),
      changeCurrentMenu,
      jumpToCourse,
      jumpToGroup,
      jumpToAllGroup,
      jumpToAllCourse,
      getName
    }
  }
})
